import {
  FaHouse,
  FaUsers,
  FaCartShopping,
  FaFolderOpen,
  FaShop,
  FaRotate,
  FaFileShield,
  FaHeadset,
  FaCalculator,
  FaBell,
  FaUtensils,
  FaKey,
  FaIdBadge,
} from "react-icons/fa6";

export const menuItems = [
    { id: "Home", icon: FaHouse, text: "Anasayfa", path: "/" },
    { id: "Customers", icon: FaUsers, text: "Müşteriler", path: "/musteriler" },
    {
      id: "Orders",
      icon: FaCartShopping,
      text: "Siparişler",
      path: "/siparisler",
    },
    {
      id: "License",
      icon: FaRotate,
      text: "Lisans Yenileme",
      path: "/lisanslar",
    },
    {
      id: "Packages",
      icon: FaFolderOpen,
      text: "Paketler",
      path: "/paketler",
      adminOnly: true,
    },
    {
      id: "Bayi",
      icon: FaShop,
      text: "Bayiler",
      path: "/bayiler",
      adminOnly: true,
    },
    {
      id: "Offer",
      icon: FaFileShield,
      text: "Teklif Koruma",
      path: "/teklifler",
    },
    {
      id: "Support",
      icon: FaHeadset,
      text: "Destek",
      path: "/destek",
    },
    {
      id: "FiyatHesaplama",
      icon: FaCalculator,
      text: "Fiyat Hesaplama",
      path: "/fiyat-hesaplama",
    },
    { id: "SistemMesajlari", icon: FaBell, text: "Sistem Mesajları", path: "/sistem-mesajlari" },
    {
      id: "GastoraLicense",
      icon: FaUtensils,
      text: "Gastro Lisans",
      adminOnly: true,
      children: [
        { id: "GastoraPackages", text: "Paketler", path: "/gastora/paketler", icon: FaFolderOpen },
        { id: "GastoraOrders", text: "Siparişler", path: "/gastora/siparisler", icon: FaCartShopping },
        { id: "GastoraLicenseRenewal", text: "Lisans Yenileme", path: "/gastora/lisanslar", icon: FaRotate },
        { id: "GastoraLicenses", text: "Lisanslar", path: "/gastora/lisans-listesi", icon: FaKey },
      ],
    },
    {
      id: "PdksLicense",
      icon: FaIdBadge,
      text: "PDKS Lisans",
      adminOnly: true,
      children: [
        { id: "PdksOrders", text: "Siparişler", path: "/pdks/siparisler", icon: FaCartShopping },
        { id: "PdksPackages", text: "Paketler", path: "/pdks/paketler", icon: FaFolderOpen },
        { id: "PdksLicenses", text: "Lisanslar", path: "/pdks/lisans-listesi", icon: FaKey },
      ],
    },
  ];
